let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("athnO")).then(() => parcelRequire('akB0l'));